import { render } from "./ZipShipContact.vue?vue&type=template&id=4478f6e5&scoped=true"
import script from "./ZipShipContact.vue?vue&type=script&lang=js"
export * from "./ZipShipContact.vue?vue&type=script&lang=js"

import "./ZipShipContact.vue?vue&type=style&index=0&id=4478f6e5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4478f6e5"]])

export default __exports__